import { def } from "#/data-layer/utility";

export const DB_NAME = "pokk-store";

// WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING
//
// Bump DB version when making changes to the list of object stores,
// as that will trigger the onUpgrade callback where we create the stores
export const DB_VERSION = 52;

export const DEFINITIONS = new Map();

export const LOOKUP_TABLES = "lookup-table";

export const ZIVAL_AGGREGATE = def(DEFINITIONS, {
  ident: "zival/zivalaggregate",
});

export const MARKING_FOAL = def(DEFINITIONS, {
  ident: "dog/oznacevanje/oznZrebe",
});

export const OCENJEVALNI_LIST_SAVE = def(DEFINITIONS, {
  ident: "dog/ocenjevanje/list/ocenjevalni-list-save",
  mode: "offline",
  service: {
    baseUrl: "/api/dog/ocenjevanje/list/ocenjevalni-list",
  },
  offline: {
    name: "dog/ocenjevanje/list/ocenjevalni-list-save",
    options: {
      keyPath: "id",
    },
  },
});

export const OCENJEVANJE_ZIVAL = def(DEFINITIONS, {
  ident: "dog/ocenjevanje/ocenjevanje-zival",
});

export const ZIVAL_ZGODOVINA = def(DEFINITIONS, {
  ident: "zival/zgodovina",
});

export const RODOVNISKA_KNJIGA = def(DEFINITIONS, {
  ident: "rod_knj/knjiga",
});

export const RODOVNISKA_KNJIGA_VPIS = def(DEFINITIONS, {
  ident: "rod_knj/knjiga/vpis",
});

export const DOGODEK_KOPITAR_PRIPUST_SEZONA = def(DEFINITIONS, {
  ident: "dog/kopitar/pripust/sezona",
});

export const DOGODEK_KOPITAR_PRIPUST_POSTAJA = def(DEFINITIONS, {
  ident: "dog/kopitar/pripust/postaja",
});

export const DOGODEK_KOPITAR_PRIPUST_POSTAJA_PREGLED = def(DEFINITIONS, {
  ident: "dog/kopitar/pripust/postaja/pregled",
});

export const DOGODEK_KOPITAR_PRIPUST_POSTAJA_PREGLED_ZREBCA = def(DEFINITIONS, {
  ident: "dog/kopitar/pripust/pregled-zrebca",
});

export const DOGODEK_ANALIZE_LABORATORIJ_VZOREC = def(DEFINITIONS, {
  ident: "dog/analize/labVzorec",
});

export const RKG_SUBJECT = def(DEFINITIONS, {
  ident: "rkg/subjekt",
});

export const RKG_SUBJECT_RESPONSIBILITIES = def(DEFINITIONS, {
  ident: "rkg/subjekt/odgovornosti",
});

export const RKG_SUBJECT_RESPONSIBILITIES_BATCH = def(DEFINITIONS, {
  ident: "rkg/vw-subjekt-odgovornosti-batch",
});

export const REJSKI_PROGRAM_MEMBERSHIPS = def(DEFINITIONS, {
  ident: "rej-prog/program/clanstvo",
});

export const REJSKI_PROGRAM = def(DEFINITIONS, {
  ident: "rej-prog/program",
});

export const OPERATIONAL_UNIT = def(DEFINITIONS, {
  ident: "rkg/gospodarstvo",
});

export const ZIVAL_IDENTIFIKATOR = def(DEFINITIONS, {
  ident: "zival/identifikator",
});

export const RKG_ODGOVORNI_SUBJEKT = def(DEFINITIONS, {
  ident: "rkg/vw-subjekt-odgovorni-subjekt-osebe",
});

export const ZASTOPNISTVO = def(DEFINITIONS, {
  ident: "varn_shema/zastopnistvo",
});

export const USER_AUTHORIZATIONS = def(DEFINITIONS, {
  ident: "varn_shema/zastopnistvo/user",
});

export const ATTACHMENTS = def(DEFINITIONS, {
  ident: "attachments",
  cache: false,
  service: {
    baseUrl: "/api/priponke/priponka",
  },
});

export const ATTACHED_ATTACHMENTS = def(DEFINITIONS, {
  ident: "attachments/attached",
  cache: false,
  service: {
    baseUrl: "/api/priponke/pripetaPriponka",
  },
});

export const USER_PARAMS = def(DEFINITIONS, {
  ident: "user-params",
  offline: {
    name: "user-params",
    options: {
      keyPath: "id",
    },
  },
});

export const ATTACHMENT_FILES = def(DEFINITIONS, {
  ident: "attachments/files",
  cache: false,
  service: {
    baseUrl: "/api/priponke/priponka",
  },
  offline: {
    name: "attachments/files",
    options: {
      keyPath: "id",
    },
  },
});

export const BREEDS = def(DEFINITIONS, {
  ident: "pasme/pasma",
  offline: {
    name: "dog/ocenjevanje/list/ocenjevalni-list-save",
    options: {
      keyPath: "id",
    },
  },
});

export const BREED_COMPOSITIONS = def(DEFINITIONS, {
  ident: "pasme/pasmaSestava",
});

export const BREED_CALCULATIONS = def(DEFINITIONS, {
  ident: "pasme/zivalPasmaIzracun",
});

export const BREED_CALCULATION_SHARES = def(DEFINITIONS, {
  ident: "pasme/zivalPasmaIzracunDelez",
});

export const OCENJEVALNI_LIST_TEMPLATE_LIST = def(DEFINITIONS, {
  ident: "dog/ocenjevanje/list/ocenjevalni-list",
});

export const OCENJEVALNI_LIST_RUNTIME_TEMPLATE_LIST = def(DEFINITIONS, {
  ident: "dog/ocenjevanje/list/ocenjevalni-list-runtime",
  service: {
    baseUrl: "/api/dog/ocenjevanje/list/ocenjevalni-list",
  },
});

export const OCENJEVALNI_LIST_TEMPLATE_DETAIL = def(DEFINITIONS, {
  ident: "dog/ocenjevanje/list/ocenjevalni-list-detail",
});

export const PASMA = def(DEFINITIONS, {
  ident: "pasme/pasma",
});

export const HORSES = def(DEFINITIONS, {
  ident: "dog/kopitar/konj",
});

// Mating logs (tracked/work overview for mating events)
export const MATTING_LOGS = def(DEFINITIONS, {
  ident: "dog/pripusti/pripust",
});

// Descendants of an animal, walked recursively over gen.geneologija.
//
// Read-only projection rather than a CRUD resource: only `/page` exists, and it
// needs `parentId` (required) and `maxGeneracija` (1..30, default 30) as query
// params on top of the usual filter/sort/page. Rows are `PotomecVo` — flat
// fields, no nested party objects.
//
// `cache` and `offline` are both disabled: there is no stable local identity to
// store (the same animal appears under different parents), and switching them
// on would add an IndexedDB object store, which needs a DB_VERSION bump.
export const DESCENDANTS = def(DEFINITIONS, {
  ident: "gen/potomci",
  cache: false,
  offline: false,
});

export const WEANINGS = def(DEFINITIONS, {
  ident: "dog/odstavitev/odstavitev",
});

export const LAMBING = def(DEFINITIONS, {
  ident: "dog/kotitve/kotitev",
});

export const FOALING = def(DEFINITIONS, {
  ident: "dog/kotitve/zrebitev",
});

export const ANIMAL_INSERTS = def(DEFINITIONS, {
  ident: "dog/vnos/vnosUvozZivali",
});

export const ANIMAL_SELECTION = def(DEFINITIONS, {
  ident: "dog/odbira/odbira",
});

export const PLEMENSKE_VREDNOSTI = def(DEFINITIONS, {
  ident: "plemenske_vrednosti",
});

export const PLEMENSKA_ZIVAL = def(DEFINITIONS, {
  ident: "plemenske_vrednosti/zival",
});

export const PLEMENSKA_VREDNOST_KODA = def(DEFINITIONS, {
  ident: "plemenske_vrednosti/koda",
});

export const KEYCLOAK = def(DEFINITIONS, {
  ident: "keycloak",
});

export const JASPER_REPORT_TEMPLATE = def(DEFINITIONS, {
  ident: "reports",
  service: {
    baseUrl: "/api/reports",
  },
});

export const JASPER_REPORT_PARAMETER = def(DEFINITIONS, {
  ident: "reports/parameter",
  service: {
    baseUrl: "/api/reports",
  },
});

export const ZIVAL_DATA_CURRENT_FOR_ZIVAL_MAT = def(DEFINITIONS, {
  ident: "zival/data/currentForZivalMat",
});

export const ZIVAL_DATA = def(DEFINITIONS, {
  ident: "zival/data",
});

// Kopitar-specific data (linija, rod, rekord, drzKob), 1:1 with a zival record
// via `zivalMatId`. The REST layer is plain CRUD even though the backend writes
// through an upsert procedure: POST rejects an existing `zivalMatId` and PUT
// requires `id` + `version`, so callers must look the record up before writing.
export const KOPITAR_PODATKI = def(DEFINITIONS, {
  ident: "zival/kopitar/podatki",
});

export const TEST_STATION_INVOICE = def(DEFINITIONS, {
  ident: "dog/testna_postaja/spremniDokument",
});

// TODO(sync): For GENEOLOGY writes, resolve by `zivalId` first (offline/online).
// If a record exists, update that record using its `id` + `version`; only create when none exists.
// On online version conflict, re-read latest by `zivalId` and retry update once.
export const GENEOLOGY = def(DEFINITIONS, {
  ident: "gen/geneologija",
});

export const USERS = def(DEFINITIONS, {
  ident: "varn_shema/uporabnik",
});

export const IDENTIFICATION_DOCUMENTS = def(DEFINITIONS, {
  ident: "dog/kopitar/identifikacija/identifikacijskiDokument",
});

export const KOPITAR_KAKOVOSTNI_RAZRED = def(DEFINITIONS, {
  ident: "dog/kopitar/konj/kakovostni-razred",
  service: {
    baseUrl: "/api/dog/kopitar/konj/kakovostni-razred/izracun",
  },
});

export const DOCX_TEMPLATES = def(DEFINITIONS, {
  ident: "docx/gen/docxTemplate",
});

export const IDENTIFICATION_DOCUMENT = def(DEFINITIONS, {
  ident: "dog/kopitar/identifikacija/identifikacijskiDokument",
});

export const MOVE = def(DEFINITIONS, {
  ident: "dog/premik",
});

export const MILKIS = def(DEFINITIONS, {
  ident: "milkis/milkisImport",
});

export const MILKIS_VALIDATE = def(DEFINITIONS, {
  ident: "milkis/milkisImport/validate",
});

export const MILKIS_VALIDATE_ONE = def(DEFINITIONS, {
  ident: "milkis/milkisImport/runValidationEnZapis/{id}",
});

export const MILKIS_TRANSFER = def(DEFINITIONS, {
  ident: "milkis/milkisImport/prenosMlecnosti",
});

export const MILKIS_TRANSFER_ONE = def(DEFINITIONS, {
  ident: "milkis/milkisImport/prenosMlecnostiEnZapis/{id}",
});

export const DOGODEK_PRASIC_KAKOVOST = def(DEFINITIONS, {
  ident: "dog/prasic/kakovost",
});

export const GENEOLOGIJA_ZIVAL = def(DEFINITIONS, {
  ident: "gen/geneologija/zival",
});

export const GENOTIPIZACIJA = def(DEFINITIONS, {
  ident: "dog/analize/genotipizacija",
});

export const LAKTACIJSKI_IZRACUNI = def(DEFINITIONS, {
  ident: "dog/mleko/izracuni/laktacijaIzracuni",
});

export const ELIMINATION = def(DEFINITIONS, {
  ident: "dog/izlocitev/izlocitev",
});

export const LAKTACIJSKI_IZRACUNI_KONTROLE = def(DEFINITIONS, {
  ident: "dog/mleko/izracuni/laktacijaPoKontroli",
});

export const SREDSTVA_ZA_TRETIRANJE = def(DEFINITIONS, {
  ident: "dog/testna_postaja/tretiranjeUcinkovina",
});
